import { TransportSedelGroup } from "api/transportSedel.api";
import { BaseClientEntity } from "./baseEntity.type";
import { Uppdrag } from "./uppdrag.type";
import { Vehicle } from "./vehicle.type";
import { Waste } from "./waste.type";
import { WasteStation } from "./wasteStation.type";
import { WasteStationNotification } from "./wasteStationNotification.type";

export type TransportSedel = BaseClientEntity & {
  wasteStation?: WasteStation;
  driverSignature?: string;
  customerSignature?: string | null;
  wasteStationSignature: string | null;
  customerSignatureUnavailable: boolean;
  wasteStationSignatureUnavailable: boolean;
  wasteList: Waste[];
  timeOfDepartureUtc?: string;
  vehicle?: Vehicle;
  status: TransportSedelStatus;
  uppdrag: Uppdrag;
  wasteStationNotificationList: WasteStationNotification[];
  preliminaryEmailStatus: PreliminaryTransportSedelEmailStatus;
};

export enum TransportSedelStatus {
  Created = "Created",
  LoadedOnTruck = "LoadedOnTruck",
  Completed = "Completed",
}

export enum PreliminaryTransportSedelEmailStatus {
  NotSent = "NotSent",
  FailedDueToMissingEmailAddress = "FailedDueToMissingEmailAddress",
  FailedForOtherReason = "FailedForOtherReason",
  Sent = "Sent",
}

export const hasAllWasteBeenWeighed = (group: TransportSedelGroup): boolean => {
  for (const vehicle of group.vehicles) {
    for (const ts of vehicle.transportSedelList) {
      for (const w of ts.wasteList) {
        if (!w.weightFinal) {
          return false;
        }
      }
    }
  }
  return true;
};

// check if a group has a transport document with status === Loaded
export const getWeighedTransportDocuments = (
  group: TransportSedelGroup,
): TransportSedel[] => {
  const result = [];
  for (const vehicle of group.vehicles) {
    for (const document of vehicle.transportSedelList) {
      if (document.status === TransportSedelStatus.LoadedOnTruck)
        result.push(document);
    }
  }
  return result;
};

export const getTransportSedelListNotSignedByWasteStation = (
  group: TransportSedelGroup,
): TransportSedel[] => {
  const result = [];
  for (const vehicle of group.vehicles) {
    for (const ts of vehicle.transportSedelList) {
      if (!ts.wasteStationSignature && !ts.wasteStationSignatureUnavailable) {
        result.push(ts);
      }
    }
  }
  return result;
};
